import React from 'react'

import { EPathSegment } from '../../../../utils'
import Icon, { EIconId } from '../../../../components/icons'

const HseLogo: React.FC = () => {
  return (
    <a className="relative block" href={EPathSegment.HOME} rel="noopener noreferrer" aria-label="Zur Startseite">
      <Icon id={EIconId.HSE_LOGO} htmlId="hse_logo" className="uif-w-67 sm:uif-w-101 text-brand-orange" />
    </a>
  )
}

export default HseLogo
